import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectAppNumber } from '../feature/app.Slice';
//import { selectUser } from '../feature/user.Slice.js';
/**
 * IsAdminHeader est un composant qui affiche un lien vers le tableau de bord si l'utilisateur est un administrateur.
 * Il utilise le hook useSelector de 'react-redux' pour accéder à l'état de l'utilisateur dans le store Redux.
 * Si l'utilisateur est un administrateur (user.is_admin est vrai), il affiche un lien vers '/dashboard'.
 * Sinon, il ne renvoie rien et n'affiche donc rien.
 *
 */

const IsAdminHeader = () => {
    const user = useSelector((state) => state.user.user.user);
    const appNumber = useSelector(selectAppNumber);
    const isApp4 = appNumber === 4;

    if (user.is_admin) {
        
        return (
            <div 
                className="bg-theme-primary text-white py-2 px-4 text-center"
                style={isApp4 ? {
                    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)'
                } : {}}
            >
                <Link 
                    to="/dashboard" 
                    className="text-white hover:text-theme-accent transition-colors duration-200 font-semibold"
                >
                    <i className="fas fa-tachometer-alt mr-2"></i>
                    Tableau de bord
                </Link>
            </div>
        );
    }

    return null;
};

export default IsAdminHeader;